import { Block, ProgressBar, useStyletron } from "@mezo-org/mezo-clay"

export type BorrowProgresProps = {
  step: number
  stepsCount: number
}

export default function BorrowProgress({
  step,
  stepsCount,
}: BorrowProgresProps) {
  const [_, theme] = useStyletron()
  return (
    <ProgressBar
      getProgressLabel={(value: number) => <Block>{value}</Block>}
      maxValue={100}
      minValue={0}
      size="medium"
      steps={stepsCount}
      value={((step - 1) / stepsCount) * 100}
      infinite={false}
      showLabel={false}
      successValue={100}
      overrides={{
        BarContainer: {
          style: {
            margin: 0,
            marginBottom: theme.sizing.scale500,
            padding: `0 ${theme.sizing.scale800} ${theme.sizing.scale600} ${theme.sizing.scale800}`,
          },
        },
      }}
    />
  )
}
